import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zhCN from './zh-CN'
import enUS from './en-US'

Vue.use(VueI18n)

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS,
}

// 默认语言（先写死，后面再做自动切换）
const locale = 'en-US'

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'zh-CN',
  messages,
  silentTranslationWarn: true,
})

export default i18n
